module.exports = __webpack_public_path__ + "static/media/how-to-pay.3236265c.png";